import { Button, Checkbox, Col, Divider, message, notification, Row } from "antd";
import React, { useState, useEffect, useRef } from "react";
import {
  Date4,
  Select4,
  Text4,
  TextArea1,
} from "../../../Components/FormComponents/InputFields";
import { Controller, useForm } from "react-hook-form";
import {
  AddressDetailAPi,
  ContactDetailAPi,
  EducationDetailAPi,
  EmpOnboarding,
  getEmployeeDetailApi,
  KnowMyTeamAPI,
} from "../../../Services/EmployeeOnboarding";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import {
  getEduColumnsConfig,
  getFamilyColumnsConfig,
} from "./Component/ComlumnConfig";
import CustomEditableTable from "./Component/IdentityTable";
import { Label } from "reactstrap";
import ApproveReject from "./Component/ApproveReject";
import axios from "axios";
import { Edit2Icon, EditIcon } from "lucide-react";

const defaultRelations = [
  { label: "father" },
  { label: "mother" },
  { label: "husband" },
  { label: "wife" },
  { label: "son" },
  { label: "daughter" },
];
const Education = [{ label: 1 }];

export default function PersonalDetails({ current, setCurrent }) {
  const {
    control,
    reset,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();
  const { dropDowns, responseData, profileData,  } = useOutletContext();
  const relationshipdrop = (dropDowns && dropDowns.RELATIONSHIP) || [];
  const [disableFields, setDisabledFields] = useState("");

  const navigate = useNavigate(null);
  const [api, contextHolder] = notification.useNotification();
   const { id } = useParams();

  const [output, setOutput] = useState(null);
  const [isUpdate,setIsUpdate] = useState(false)
  const [output2, setOutput2] = useState(null);

  const [tableData, setTableData] = useState(defaultRelations);
  const [tableData2, setTableData2] = useState(Education);

  const [isLoading, setIsLoading] = useState(false);

  const handleAddRow = () => {
    setTableData((prev) => {
     
      const childNumbers = prev
        .map((item) => {
          const match = item.label.match(/^Child (\d+)$/);
          return match ? parseInt(match[1], 10) : null;
        })
        .filter((num) => num !== null);

     
      const maxChildNumber = childNumbers.length
        ? Math.max(...childNumbers)
        : 0;

     
      return [
        ...prev,
        {
          label: `Child ${maxChildNumber + 1}`,
          
        },
      ];
    });
  };

  const handleRemoveRow2 = (labelToRemove) => {
    setTableData2((prev) => prev.filter((row) => row.label !== labelToRemove));
  };

  const handleAddRow2 = () => {
    setTableData2((prev) => [
      ...prev,
      {
        label: generateUniqueLabel(),
      },
    ]);
  };

  const handleRemoveRow = (labelToRemove) => {
    setTableData((prev) => prev.filter((row) => row.label !== labelToRemove));
  };
  const handleChangeValue = (value, field, relation) => {
    setOutput((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
      },
    }));
  };

  const handleChangeValue2 = (value, field, relation) => {
    setOutput2((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
      },
    }));
  };

  const familycolumnsConfig = getFamilyColumnsConfig(
    handleChangeValue,
    relationshipdrop
  );
  const educolumnsConfig = getEduColumnsConfig(handleChangeValue2);

  const counter = useRef(0);

  function generateUniqueLabel() {
    return (
      "id-" +
      (counter.current++).toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 5)
    );
  }

  const onSubmit = async (val) => {
    const arrayOfValues = Object.values(output);

    const family_details = Object.entries(output).map(([key, value]) => ({
      ...value,
      relationship: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize: father → Father
    }));

    const payload = {
      title: val.title,
      full_name: val.full_name,
      dob: val.birthDate,
      gender: val.gender,
      height: val.height ? val.height : "",
      weight: val.weight ? val.weight : "",
      blood_group: val.bloodGroup,
      nationality: val.nationality ? val.nationality : "",
      city: val.cityBirth ? val.cityBirth : "",
      state: val.stateBirth ? val.stateBirth : "",
      country: val.countryBirth,
      religion: val.religion ? val.religion : "",
      marital_status: val.maritalStatus,
      marriage_date: val.marriageDate,
      family_details,
    };
    console.log(payload);

    try {
      const { data } = await EmpOnboarding(payload, isUpdate, id);
      console.log(data, "chekcing datta");
      if (data?.success) {
        handleContactDetailsSubmit(val);
        api.success({ message: data.message, placement: "top" });
      } else {
        api.error({
          message: data.message,
          placement: "top",
        });
      }
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  const handleContactDetailsSubmit = async (val) => {
    const payload = {
      mobile_number: val.mobilePrimary || "",
      alternate_mobile_number: val.alternateNumber || "",
      personal_email_id: val.personalEmail || "",
      work_email_id: val.workEmail || "",
      emergency_contact_name: val.emergencyContactName || "",
      emergency_contact_number: val.emergencyContactNumber || "",
      emergency_contact_relationship: val.emergencyContactRelationship || "",
    };

    try {
      const response = await ContactDetailAPi(payload, isUpdate, id);
      if (response?.data?.success) {
        handleAddressDetailsSubmit(val);
        api.success({ message: response?.data.message, placement: "top" });
        return;
      } else {
        if (response?.data?.message === "Contact details already updated") {
          handleAddressDetailsSubmit(val);
        } else {
          api.error({
            message: response?.data.errors[0],
            placement: "top",
          });
        }

        return;
        // throw new Error("Submission failed: " + response?.data?.status);
      }
    } catch (error) {
      console.error("Failed to submit contact details:", error);
    }
  };

  const handleAddressDetailsSubmit = async (val) => {
    const payload = {
      current_street: val.currentStreet || "",
      current_city: val.currentCity || "",
      current_state: val.currentState || "",
      current_pincode: val.currentPincode || "",
      permanent_street: val.permanentStreet || "",
      permanent_city: val.permanentCity || "",
      permanent_state: val.permanentState || "",
      permanent_pincode: val.permanentPincode || "",
      is_permanent_same: val.isPermanentSame === "Yes",
      pg_landlord_name: val.pgLandlordName || "",
      pg_contact_number: val.pgContactNumber || "",
    };

    try {
      const response = await AddressDetailAPi(payload, isUpdate, id);

      if (response?.data?.success) {
        handleEducationDetailsSubmit(val);
        api.success({ message: response?.data.message, placement: "top" });
        return;
      } else {
        if (response?.data?.message === "Address details already updated") {
          handleEducationDetailsSubmit(val);
        } else {
          api.error({
            message: response?.data.message,
            placement: "top",
          });
        }

        return;
        // throw new Error("Submission failed: " + response?.data?.status);
      }
    } catch (error) {
      console.error("Failed to submit address details:", error);
    }
  };

  const handleEducationDetailsSubmit = async (val) => {
    const arrayOfValues = Object.values(output2);

    const education = arrayOfValues?.map((entry) => ({
      qualification: entry?.qualification || "",
      stream: entry?.stream || "",
      board: entry?.board || "",
      year_of_passing: entry?.year_of_passing || "",
      grade_cgpa: entry?.grade_cgpa || "",
    }));

    try {
      const { data } = await EducationDetailAPi(education, isUpdate, id);
      console.log(data);
      if (data?.success) {
        handleKnowMyTeamSubmit(val);
        api.success({ message: data.message, placement: "top" });
        return;
      } else {
        api.error({
          message: data.message,
          placement: "top",
        });
        return;
        // throw new Error("Failed with status " + data.status);
      }
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  const handleKnowMyTeamSubmit = async (val) => {
    const payload = {
      nick_name: val.nick_name || "",
      native_place: val.native_place || "",
      favourite_movie: val.favourite_movie || "",
      favourite_actor: val.favourite_actor || "",
      favourite_cuisine: val.favourite_cuisine || "",
      like_to_do_most: val.like_to_do_most || "",
      hates_most: val.hates_most || "",
      role_model: val.role_model || "",
      favourite_song: val.favourite_song || "",
      life_best_Day: val.life_best_Day || "",
      philosophy_of_life: val.philosophy_of_life || "",
      struggle_of_life: val.struggle_of_life || "",
      favourite_place: val.favourite_place || "",
      dreams_of_life: val.dreams_of_life || "",
      makes_you_happy: val.makes_you_happy || "",
      makes_you_sad: val.makes_you_sad || "",
    };

    try {
      const res = await KnowMyTeamAPI(payload, isUpdate, id);
      if (res.data?.success) {
        console.log(responseData?.final_submit);
        if(isUpdate) {
           setIsUpdate(false)
             api.success({ message: res?.data.message, placement: "top" });
            return
           }
        if (responseData?.final_submit) {
          handleSubmitFinal();
        } else {
              navigate("/new-user/identity-detail");
          
        }
        api.success({ message: res?.data.message, placement: "top" });
      } else {
        api.error({
          message: res?.data.message,
          placement: "top",
        });
        throw new Error(
          "Submission failed: " + (res.data?.message || "Unknown error")
        );
      }
    } catch (error) {
      console.error("Error submitting Know My Team form:", error);
    }
  };
  const handleSubmitFinal = async () => {
    const { data } = await axios.post("/api/employees/final-submit", {
      final_submit: true,
    });

    if (data?.success) {
      api.success({
        message: data?.message,
        placement: "top",
      });
      navigate("/new-user/identity-detail");
    } else {
      api.error({
        message: data?.message,
        placement: "top",
      });
    }

    console.log("hellow");
  };

  const onError = (e) => {
    console.log(e);
  };

  const getPersonalDetail = async () => {
    // const responseData = await fetchDataDianamic("personal_details");
    // if (!responseData) return false;

    const personalDetails = responseData?.personal_details || {};
    const birth = responseData?.birth || {};
    const profile = profileData || {};
    const disableFields = {};

    const getValue = (path) => {
      const profileVal = path.reduce((acc, key) => acc?.[key], profile);
      const responseVal = path.reduce((acc, key) => acc?.[key], responseData);

      const fieldKey = path.join(".");

      if (
        profileVal !== undefined &&
        profileVal !== null &&
        profileVal !== ""
      ) {
        disableFields[fieldKey] = true;
        return profileVal;
      }

      return responseVal;
    };

    if (profile?.know_my_team) {
      Object.entries(profile.know_my_team).forEach(([key, val]) => {
        if (val !== undefined && val !== null && val !== "") {
          disableFields[`know_my_team.${key}`] = true;
        }
      });
    }

    const updatedValues = {
      title: getValue(["title"]),
      full_name: getValue(["name", "full_name"]),
      birthDate: getValue(["birth", "dob"]),
      gender: getValue(["gender"]),
      height: getValue(["personal_details", "height"]),
      weight: getValue(["personal_details", "weight"]),
      bloodGroup: getValue(["blood_group"]),
      nationality: getValue(["personal_details", "nationality"]),
      cityBirth: getValue(["birth", "place"]),
      stateBirth: getValue(["birth", "state"]),
      countryBirth: getValue(["birth", "country"]),
      religion: getValue(["personal_details", "religion"]),
      maritalStatus: getValue(["personal_details", "marital_status", "status"]),
      marriageDate: getValue([
        "personal_details",
        "marital_status",
        "marriage_date",
      ]),
      mobilePrimary: getValue(["mobile"]),

      emergencyContactNumber: getValue([
        "contact_details",
        "emergency_contact_number",
      ]),
      emergencyContactName: getValue([
        "contact_details",
        "emergency_contact_name",
      ]),
      emergencyContactRelationship: getValue([
        "contact_details",
        "emergency_contact_relationship",
      ]),
      alternateNumber: getValue(["contact_details", "alternate_mobile_number"]),
      personalEmail: getValue(["email", "personal"]),
      workEmail: getValue(["email", "company"]),

      currentStreet: getValue(["address_details", "current_address", "street"]),
      currentCity: getValue(["address_details", "current_address", "city"]),
      currentState: getValue(["address_details", "current_address", "state"]),
      currentPincode: getValue([
        "address_details",
        "current_address",
        "pincode",
      ]),
      isPermanentSame: getValue(["address_details", "is_permanent_same"]),

      permanentStreet: getValue([
        "address_details",
        "permanent_address",
        "street",
      ]),
      permanentCity: getValue(["address_details", "permanent_address", "city"]),
      permanentState: getValue([
        "address_details",
        "permanent_address",
        "state",
      ]),
      permanentPincode: getValue([
        "address_details",
        "permanent_address",
        "pincode",
      ]),
      pgLandlordName: getValue([
        "address_details",
        "pg_details",
        "landlord_name",
      ]),

      pgContactNumber: getValue([
        "address_details",
        "pg_details",
        "contact_number",
      ]),

      // Spread know_my_team fields here (values will be taken from responseData)
      ...responseData?.know_my_team,
    };

    const educationList = responseData?.education_details?.education;

    setOutput2(() => {
      const updated = {};
      educationList?.forEach((item, index) => {
        updated[index + 1] = { ...item };
      });
      return updated;
    });

    setOutput((prev) => {
      const updated = { ...prev };
      Object.entries(personalDetails?.family_details || {}).forEach(
        ([key, value]) => {
          updated[key] = { ...value };
        }
      );
      return updated;
    });

    setDisabledFields(disableFields); // Set all disable flags before reset
    reset(updatedValues);
  };

  const {
    personal_details_meta,
    contact_details_meta,
    education_details_meta,
    address_details_meta,
    know_my_team_meta,
  } = responseData?.final_submit || {};

  const is_Final_submit =
    personal_details_meta?.final_submit === true &&
    contact_details_meta?.final_submit === true &&
    education_details_meta?.final_submit === true &&
    address_details_meta?.final_submit === true &&
    know_my_team_meta?.final_submit === true;

  const is_approve =
    personal_details_meta?.is_approved === true &&
    contact_details_meta?.is_approved === true &&
    education_details_meta?.is_approved === true &&
    address_details_meta?.is_approved === true &&
    know_my_team_meta?.is_approved === true;

  const type = sessionStorage.getItem("userType");
  useEffect(() => {
    if (responseData) {
      getPersonalDetail();
      setDisabledFields((prev) => ({
        ...prev,
        ["name.full_name"]: true,
        ["birth.dob"]: true,
        ["gender"]: true,
        ["mobile"]: true,
        ["email.personal"]: true,
      }));
    }
  }, [responseData]);
  return (
    <>
      {contextHolder}
      <form
        className="responsive-form h-full"
        onSubmit={handleSubmit(onSubmit, onError)}
      >
        <Row className="align-content-start  w-full ">
          <Col className={`px-3 mb-4 text-justify`} span={24}>
          <div className="flex justify-between">
            
            <h2 class="text-[#00a0e4] font-bold text-xl flex items-center">
              <span class="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Personal Details
            </h2>
          
          <Col>

          {isUpdate &&  <Button onClick={()=>setIsUpdate(false)}  style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }} shape="circle" icon={ <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
</svg> }> 
         </Button>||  <Button onClick={()=>setIsUpdate(true)}  style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }} shape="circle" icon={<svg  xmlns="http://www.w3.org/2000/svg" width="16"  fill="currentColor" className="bi bi-pencil-fill m-auto " viewBox="0 0 16 16">
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
            </svg>}> 
         </Button> }
        
          </Col>
          </div>
          </Col>
          
          <Select4
            control={control}
            errors={errors}
            id="title"
            name="Title"
            disabled={disableFields["title"]}
            options={[
              { label: "Mr", value: "mr" },
              { label: "Ms", value: "ms" },
              { label: "Mrs", value: "mrs" },
            ]}
          />
          <Text4
            control={control}
            errors={errors}
            id="full_name"
            name="Full Name (as per Aadhar)"
            disabled={disableFields["name.full_name"]}
            validations={{
              required: true,
              message: "Full name is required",
            }}
          />

          <Date4
            control={control}
            errors={errors}
            id="birthDate"
            name="Date of Birth"
            disabled={disableFields["birth.dob"]}
            validations={{
              required: true,
            }}
          />
          <Text4
            control={control}
            errors={errors}
            id="cityBirth"
            name="City of Birth"
            disabled={disableFields["birth.place"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="stateBirth"
            name="State of Birth"
            disabled={disableFields["birth.state"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="countryBirth"
            name="Country of Birth"
            disabled={disableFields["birth.country"]}
          />
          <Select4
            control={control}
            errors={errors}
            id="bloodGroup"
            disabled={disableFields["blood_group"]}
            name="Blood Group"
            options={dropDowns && dropDowns.BLOOD_GROUP}
          />
          <Select4
            control={control}
            errors={errors}
            id="gender"
            name="Gender"
            disabled={disableFields["gender"]}
            options={[
              { label: "Male", value: "male" },
              { label: "Female", value: "female" },
            ]}
          />
          <Text4
            control={control}
            errors={errors}
            id="nationality"
            name="Nationality"
            disabled={disableFields["personal_details.nationality"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="religion"
            name="Religion"
            disabled={disableFields["personal_details.religion"]}
          />

          <Text4
            control={control}
            errors={errors}
            disabled={disableFields["personal_details.height"]}
            id="height"
            name="Height"
          />
          <Text4
            control={control}
            errors={errors}
            disabled={disableFields["personal_details.weight"]}
            id="weight"
            name="Weight"
          />
          <Col className={`px-3 mb-4 text-justify`} span={24}>
            <h2 class="text-[#00a0e4] font-bold text-xl flex items-center">
              <span class="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Marital Status
            </h2>
          </Col>
          <Select4
            control={control}
            errors={errors}
            id="maritalStatus"
            name="Marital status"
            disabled={disableFields["personal_details.marital_status.status"]}
            options={[
              { label: "Married", value: "married" },
              { label: "Unmarried", value: "Unmarried" },
            ]}
          />
          <Date4
            control={control}
            errors={errors}
            id="marriageDate"
            disabled={
              disableFields["personal_details.marital_status.marriage_date"]
            }
            name="Date of Marriage"
          />
        </Row>
        <Col className={`px-3 mb-4 text-justify`} span={24}>
          <h2 class="text-[#00a0e4] font-bold text-xl flex items-center">
            <span class="w-1 h-full bg-[#00a0e4] mr-2">|</span>
            Family Details
          </h2>
        </Col>
        <div className=" w-full mb-4 ml-2">
          <CustomEditableTable
            handleAddRow={handleAddRow}
            handleRemoveRow={handleRemoveRow}
            columnsConfig={familycolumnsConfig}
            tableData={tableData}
            setTableData={setTableData}
            output={output}
            setOutput={setOutput}
            isLoading={isLoading}
          />
        </div>

        <Row className="align-content-start  w-full ">
          <Col className={`px-3 mb-4 text-justify`} span={24}>
            <h2 className="text-[#00a0e4] font-bold text-xl flex items-center">
              <span className="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Contact Information
            </h2>
          </Col>

          <Text4
            control={control}
            errors={errors}
            id="mobilePrimary"
            disabled={disableFields["mobile"]}
            name="Mobile Number (Primary)"
            type="number"
            validations={{
              required: true,
              pattern: {
                value: /^\d{10}$/,
                message: "Number must be exactly 10 digits",
              },
            }}
            maxLength={10}
          />

          <Text4
            control={control}
            errors={errors}
            id="alternateNumber"
            name="Alternate Number"
            disabled={disableFields["contact_details.alternate_mobile_number"]}
          />

          <Text4
            control={control}
            errors={errors}
            id="personalEmail"
            name="Personal Email Id"
            disabled={disableFields["email.personal"]}
            validations={{
              required: true,
            }}
          />

          <Text4
            control={control}
            errors={errors}
            id="workEmail"
            name="Work Email Id"
            disabled={disableFields["email.company"]}
          />

          <Text4
            control={control}
            errors={errors}
            id="emergencyContactName"
            name="Emergency Contact Name"
            disabled={disableFields["contact_details.emergency_contact_name"]}
          />

          <Text4
            control={control}
            errors={errors}
            id="emergencyContactRelationship"
            name="Emergency Contact Relationship"
            disabled={
              disableFields["contact_details.emergency_contact_relationship"]
            }
          />

          <Text4
            control={control}
            errors={errors}
            id="emergencyContactNumber"
            name="Emergency Contact Number"
            disabled={disableFields["contact_details.emergency_contact_number"]}
          />

          <Col className="px-3 mb-4 text-justify" span={24}>
            <h2 className="text-[#00a0e4] font-bold text-xl flex items-center">
              <span className="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Address Details
            </h2>
          </Col>

          <TextArea1
            control={control}
            errors={errors}
            id="currentStreet"
            name="Current Residential Address"
            placeholder="Enter Street"
            disabled={disableFields["address_details.current_address.street"]}
          />
          <Text4
            control={control}
            errors={errors}
            disabled={disableFields["address_details.current_address.city"]}
            id="currentCity"
            name="City"
          />
          <Text4
            control={control}
            errors={errors}
            id="currentState"
            name="State"
            disabled={disableFields["address_details.current_address.state"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="currentPincode"
            name="Pincode"
            validations={{
              required: true,
            }}
            disabled={disableFields["address_details.current_address.pincode"]}
          />
        </Row>
        <Row className="align-content-start  w-full ">
          <Col className={`px-3 py-3 `} lg={6} sm={12} xs={24}>
            <Row
              className="align-items-end position-relative"
              style={{ height: "100%", width: "100%" }}
            >
              <Label className="fs-6 text-secondary" for={"isPermanentSame"}>
                Is the Permanent Address same as Current?
              </Label>
              <Controller
                control={control}
                name="isPermanentSame"
                render={({ field }) => {
                  const isDisabled =
                    disableFields["address_details.is_permanent_same"];
                  return (
                    <>
                      <Checkbox
                        checked={field.value === true}
                        onChange={(e) => {
                          const isChecked = e.target.checked ? true : null;
                          field.onChange(isChecked);

                          // If user selects "Yes", copy values from current to permanent
                          if (isChecked) {
                            setValue(
                              "permanentStreet",
                              getValues("currentStreet")
                            );
                            setValue("permanentCity", getValues("currentCity"));
                            setValue(
                              "permanentState",
                              getValues("currentState")
                            );
                            setValue(
                              "permanentPincode",
                              getValues("currentPincode")
                            );
                          }
                        }}
                        disabled={isDisabled}
                      >
                        Yes
                      </Checkbox>
                      <Checkbox
                        checked={field.value === false}
                        onChange={(e) => {
                          const isChecked = e.target.checked ? false : null;
                          field.onChange(isChecked);

                          // Optional: Clear permanent address if "No" is selected
                          if (isChecked === false) {
                            setValue("permanentStreet", "");
                            setValue("permanentCity", "");
                            setValue("permanentState", "");
                            setValue("permanentPincode", "");
                          }
                        }}
                        disabled={isDisabled}
                      >
                        No
                      </Checkbox>
                    </>
                  );
                }}
              />
            </Row>
          </Col>
        </Row>
        <Row className="align-content-start  w-full ">
          <TextArea1
            control={control}
            errors={errors}
            id="permanentStreet"
            name="Permanent Address"
            placeholder="Enter Street"
            disabled={disableFields["address_details.permanent_address.street"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="permanentCity"
            name="City"
            disabled={disableFields["address_details.permanent_address.city"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="permanentState"
            name="State"
            disabled={disableFields["address_details.permanent_address.state"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="permanentPincode"
            name="Pincode"
            disabled={
              disableFields["address_details.permanent_address.pincode"]
            }
          />
        </Row>

        <Row className="align-content-start  w-full ">
          <Text4
            control={control}
            errors={errors}
            id="pgLandlordName"
            name="Name of PG/Landlord (if in PG)"
            disabled={disableFields["address_details.pg_details.landlord_name"]}
          />

          <Text4
            control={control}
            errors={errors}
            id="pgContactNumber"
            name="PG Contact Number"
            disabled={
              disableFields["address_details.pg_details.contact_number"]
            }
          />
        </Row>

        <Col className={`px-3 mb-4 text-justify`} span={24}>
          <h2 class="text-[#00a0e4] font-bold text-xl flex items-center">
            <span class="w-1 h-full bg-[#00a0e4] mr-2">|</span>
            Education Background
          </h2>
        </Col>
        <div className=" w-full mb-4 ml-2">
          <CustomEditableTable
            handleAddRow={handleAddRow2}
            handleRemoveRow={handleRemoveRow2}
            columnsConfig={educolumnsConfig}
            tableData={tableData2}
            setTableData={setTableData2}
            output={output2}
            setOutput={setOutput2}
            isLoading={isLoading}
          />
        </div>

        <Row className="align-content-start  w-full ">
          <Col className="px-3 mb-4 text-justify" span={24}>
            <h2 className="text-[#00a0e4] font-bold text-xl flex items-center">
              <span className="w-1 h-full bg-[#00a0e4] mr-2">|</span>I Know My
              Team
            </h2>
          </Col>
          <Text4
            control={control}
            errors={errors}
            id="nick_name"
            name="Nick Name"
            disabled={disableFields["know_my_team.nick_name"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="native_place"
            name="Native Place"
            disabled={disableFields["know_my_team.native_place"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="favourite_movie"
            name="Favourite Movie"
            disabled={disableFields["know_my_team.native_place"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="favourite_actor"
            disabled={disableFields["know_my_team.favourite_actor"]}
            name="Favourite Actress/Actor"
          />
          <Text4
            control={control}
            errors={errors}
            id="favourite_cuisine"
            name="Favourite Cuisine"
            disabled={disableFields["know_my_team.favourite_cuisine"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="like_to_do_most"
            name="Like to do most"
            disabled={disableFields["know_my_team.like_to_do_most"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="hates_most"
            name="Hates most"
            disabled={disableFields["know_my_team.hates_most"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="role_model"
            disabled={disableFields["know_my_team.role_model"]}
            name="Role Model"
          />
          <Text4
            control={control}
            errors={errors}
            id="favourite_song"
            name="Favourite Song"
            disabled={disableFields["know_my_team.favourite_song"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="life_best_Day"
            disabled={disableFields["know_my_team.life_best_Day"]}
            name="Life’s Best Day"
          />
          <Text4
            control={control}
            errors={errors}
            id="philosophy_of_life"
            name="Philosophy of Life"
            disabled={disableFields["know_my_team.philosophy_of_life"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="struggle_of_life"
            name="Struggle of Life"
            disabled={disableFields["know_my_team.struggle_of_life"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="favourite_place"
            name="Favourite Places"
            disabled={disableFields["know_my_team.favourite_place"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="dreams_of_life"
            name="Dreams of Life"
            disabled={disableFields["know_my_team.dreams_of_life"]}
          />
          <Text4
            control={control}
            errors={errors}
            id="makes_you_happy"
            disabled={disableFields["know_my_team.makes_you_happy"]}
            name="What makes you Happy"
          />
          <Text4
            control={control}
            errors={errors}
            id="makes_you_sad"
            name="What makes you Sad"
            disabled={disableFields["know_my_team.makes_you_sad"]}
          />
        </Row>
        <Row className="step-buttons-box justify-content-end pt-3 px-2">
          {type !== "admin" && (
            <button
              disabled={is_Final_submit}
              className="m-2 text-white step-button"
              type="submit"
            >
               Submit
            </button>
          ) || <>{isUpdate && <button
              className="m-2 text-white step-button"
              type="submit"
            >
               Update 
            </button> }</>}{" "}
        </Row>
      </form>
      {type === "admin" && is_Final_submit && (
        <>
          {is_approve !== true && (
            <ApproveReject
              id={id}
              redirect="identity-detail"
              detailType={[
                "personal_details",
                "contact_details",
                "address_details",
                "education_details",
                "know_my_team",
              ]}
            />
          )}
        </>
      )}
    </>
  );
}
